// One rule for both field editors — the activity's and the offer's. An answer
// is filed under its field's key forever, so two fields sharing one key would
// overwrite each other's answers the moment a customer filled both in.

/** Blank keys are not a collision: a row the partner has only just added has no
 *  key yet, and gets one from its label. */
export function firstDuplicateKey(keys: readonly string[]): string | null {
  const seen = new Set<string>();
  for (const key of keys) {
    if (!key) continue;
    if (seen.has(key)) return key;
    seen.add(key);
  }
  return null;
}

export function duplicateKeyRefusal(label: string): string {
  return `„${label}“ už v seznamu je — přejmenujte jeden z nich, ať se každý ptá na něco jiného`;
}
